import { atom } from "recoil"

const generalHistoryAtom = atom({
    key: 'generalHistory',
    default: {}
})

export default generalHistoryAtom